import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiPrinter, FiScissors, FiShield } from 'react-icons/fi';

const steps = [
  {
    icon: FiPrinter,
    title: "1. Print at Home",
    desc: "Use high-quality photo paper or cardstock. Our designs are high-resolution to ensure every verse is crisp and easy to read.",
    imgUrl: "https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/704422e199609735f5b8a9e6b95e11d3.png"
  },
  {
    icon: FiScissors,
    title: "2. Precision Cut",
    desc: "Cut carefully along the lines to trim your bookmarks. Scaling them up or down is easy before you hit print!",
    imgUrl: "https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/979f04307f02a9470c0827f91391650c.png"
  },
  {
    icon: FiShield,
    title: "3. Laminate for Durability",
    desc: "Use a home laminator or clear laminate sheets to create a sturdy, long-lasting bookmark that stands up to daily use.",
    imgUrl: "https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/6dea2c61aea17b31abfff90f41479029.png"
  }
];

const HowItWorks = () => {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4">Create Your Own in 3 Simple Steps</h2>
          <p className="text-lg text-stone-600">Transform your digital download into a physical symbol of devotion you can carry anywhere.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-stone-100 hover:shadow-md transition-shadow">
              <div className="bg-amber-100 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={step.icon} className="text-2xl text-amber-600" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3">{step.title}</h3>
              <p className="text-stone-600 mb-6 min-h-[80px]">{step.desc}</p>
              
              <div className="rounded-xl overflow-hidden bg-stone-100 aspect-square">
                <img 
                  src={step.imgUrl} 
                  alt={step.title} 
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;